let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("35Vym")).then(() => parcelRequire('id8PS'));